// extracted by mini-css-extract-plugin
export default {"enrollmentIcon":"Enrollment_enrollmentIcon__1C4tH","container":"Enrollment_container__vfHe5","uploadBtn":"Enrollment_uploadBtn__G4xOh"};